// extracted by mini-css-extract-plugin
module.exports = {"recipientContainer":"ElectronicDelivery_recipientContainer__3Ca1z","alertCol":"ElectronicDelivery_alertCol__1IQBi","docCheckbox":"ElectronicDelivery_docCheckbox__LqMkH"};